<!-- 客户邮件 -->
<template>
  <div class="content">
    <div class="filter">
      <el-button type="primary" @click="jumpDetail('add')">新增</el-button>
      <el-input v-model="listForm.popupName" style="width:200px" placeholder="请输入弹窗名称" @change="initPage"></el-input>
      <el-select v-model="listForm.status" placeholder="状态" @change="initPage" style="width:120px;" clearable>
        <el-option label="未开始" :value="1"></el-option>
        <el-option label="进行中" :value="2"></el-option>
        <el-option label="已结束" :value="3"></el-option>
      </el-select>
      <el-date-picker v-model="registerDate" type="daterange" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp" :default-time="['00:00:00', '23:59:59']" @change="handleDatePick"></el-date-picker>
    </div>

    <el-table :data="popupList" height="calc(100vh - 198px)" >
     <el-table-column label="序号" width="60" :show-overflow-tooltip="true">
       <template slot-scope="{$index}">
         <span>{{ $index+1 }}</span>
       </template>
     </el-table-column>
      <el-table-column prop="popupName" label="弹窗名称" min-width="140" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column label="生效日期" min-width="220">
        <template slot-scope="{row}">
          <span v-if="row.popupRules.is_long">长期</span>
          <span v-else>{{getDateFormat(row.effectiveStartTime)}} ~ {{getDateFormat(row.effectiveEndTime)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="90">
        <template slot-scope="{row}">
          <span>{{row.status===1?'未开始':row.status===2?'进行中':row.status===3?'已结束':''}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="exposureCount" label="曝光次数"  min-width="90"></el-table-column>
      <el-table-column prop="clickCount" label="点击次数"  min-width="90"></el-table-column>
      <el-table-column prop="modifier" label="最后更新人" min-width="120"></el-table-column>
      <el-table-column label="最后更新时间" min-width="160">
        <template slot-scope="{row}">
          <span>{{getDateFormat(row.modifyDate)}}</span><br>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="{row}">
          <el-button v-if="row.status !== 3" type="text" size="medium" @click="jumpDetail('edit', row.id)">编辑</el-button>
          <el-button v-if="row.status === 3" type="text" size="medium" @click="jumpDetail('detail', row.id)">详情</el-button>
          <el-button v-if="row.status === 1" type="text" size="medium" @click="deleteEmail(row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="f-b-c bg-white" style="padding: 10px">
      <div></div>
      <el-pagination background :current-page="listForm.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="listForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="sizeChange" @current-change="pageChange" />
    </div>
  </div>
</template>

<script>
import API from '@/api'
import { dateFormat } from '@/utils/date'
export default {
  name: 'operation_advertisingPopups',
  data() {
    return {
      listForm: {
        pageNumber: 1,
        pageSize: 20,
        type: 0
      },
      total: 0,
      registerDate: [],
      popupList: []
    }
  },
  created() {
    this.getAdPopupsList()
  },
  methods: {
    getAdPopupsList(){
      API.getAdPopupsList(this.listForm).then(res => {
        this.total = res.data.total
        this.popupList = res.data.list
      })
    },

    deleteEmail(id){
      this.$confirm('是否删除该弹窗','提示',{
        confirmButtonText:'确定',
        cancelButtonText:'取消',
        type:'warning'
      }).then(()=>{
        API.deleteAdPopups(id).then(res=>{
          if(res.code===10000){
            this.getAdPopupsList()
          }else{
            this.$message.error(res.message)
          }
        })
      })
    },

    getDateFormat(date){
      return dateFormat(date)
    },

    //时间筛选
    handleDatePick(value) {
      if (value && value.length === 2) {
        this.listForm.effectiveStartTime = value[0]
        this.listForm.effectiveEndTime = value[1]
      } else {
        this.listForm.effectiveStartTime = undefined
        this.listForm.effectiveEndTime = undefined
      }
      this.initPage()
    },

    //切换筛选条件
    handleChange() {
      this.listForm.searchContent = ''
    },

    initPage() {
      this.listForm.pageNumber = 1
      let listForm = this.listForm
      for (let key in listForm) {
        if (!listForm[key] && listForm[key] !== 0) {
          listForm[key] = undefined
        }
      }
      this.$set(this.$data, 'listForm', listForm)
      this.getAdPopupsList()
    },
    sizeChange(size) {
      this.listForm.pageSize = size
      this.getAdPopupsList()
    },
    pageChange(page) {
      this.listForm.pageNumber = page
      this.getAdPopupsList()
    },

    jumpDetail(type, id) {
      this.$router.push({ path: '/operation/advertisingPopups/add', query: { type, id }})
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  background: #ffffff;
  padding: 12px 12px 0;
  .filter {
    padding: 12px;
    & > div {
      margin-left: 12px;
    }
    /deep/.el-input-group {
      width: 300px;
    }
    /deep/.el-input-group__prepend {
      width: 100px;
    }
  }
}
</style>
